import { render, staticRenderFns } from "./CeldaDateText.vue?vue&type=template&id=7d5fecd2&scoped=true&"
import script from "./CeldaDateText.vue?vue&type=script&lang=js&"
export * from "./CeldaDateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5fecd2",
  null
  
)

export default component.exports